import * as React from 'react';
import { SVGProps } from 'react';

export const LikeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M7.5 13.334V9.403c0-1.208.525-2.357 1.438-3.149L13.27 2.5a.833.833 0 0 1 1.008-.064l.132.088c.34.227.466.666.297 1.038l-1.523 3.35a.417.417 0 0 0 .38.588h1.187c1.943 0 3.144 2.12 2.144 3.787l-2 3.333a2.5 2.5 0 0 1-2.144 1.214H10a2.5 2.5 0 0 1-2.5-2.5ZM5 7.5c-.92 0-1.667.747-1.667 1.667v5a1.667 1.667 0 1 0 3.334 0v-5C6.667 8.247 5.92 7.5 5 7.5Z"
    />
  </svg>
);
